<template>
    <div class="vertical grow gallery-container" :style="(photos.length > 0) ? 'width: 70vw; height: 100%' : 'width: 28vw; height: 100%'">
        <div :class="(photos.length > 0) ? 'two-columns-template-modal' : 'one-column-template-modal'" style="margin-top: 5px;">
            <div>
                <div v-if="(existingProblem != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('System')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{existingProblem.systemName}}</span>
                        </td>
                    </tr>
                </div>
                <div v-if="(existingProblem != null)" class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Device')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{existingProblem.deviceName}}</span>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Title')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{ selectedObject.title }}</span>
                        </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('Description')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{ selectedObject.description }}</span>
                          </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('ReportedDate')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{ selectedObject.reportedDate }}</span>
                          </td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;"><p class="info-field-title">{{$t('ResolvedDate')}}</p></td>
                        <td style="width:200px;" class="info-field-value">
                            <span>{{ selectedObject.resolvedDate }}</span>
                          </td>
                    </tr>
                </div>
            </div>
            <div style="background-color: rgba(243, 243, 243, 1)" v-if="(photos.length > 0)">
                <div id="photos-container" style="margin: auto;">
                    <div class="vertical" style="margin: auto;">
                        <div style="width: calc(0.5 * 70vw); height: 50vh; align-self: center; text-align: center; overflow: hidden; white-space: nowrap;" v-if="(photos.length > 0)">
                            <i class="arrow left" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(-1)"></i>
                            <img class="photo" :src="photos[activePhotoIndex].url" >
                            <i class="arrow right" :style="[photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]" @click="changePhoto(1)"></i>
                        </div>
                        <div class="thumbnails horizontal" style="padding-bottom: 10px;">
                            <div v-for="(photo, index) in photos" :key="index" @click="activePhotoIndex = index">
                                <div class="thumbnail-container">
                                    <img :src="photo.url" class="thumbnail" v-bind:class="{ selectedThumbnail: activePhotoIndex == index}"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getProblemPhotos } from '@/api/api';
import moment from 'moment';

export default {
    props: {
        existingProblem: {
            required: false,
            default: null,
            type: Object
        },
    },
    components: {
    },
    data() {
        return {
            selectedObject: {
                deviceId: null,
                systemId: null,
                visitId: null,
                description: null,
                title: null
            },

            photos: [],
            activePhotoIndex: 0
        }
    },
    methods: {
        async loadExistingProblem() {
            this.selectedObject = Object.assign({}, this.existingProblem)

            this.selectedObject.reportedDate = moment(this.selectedObject.reportedDate).format('YYYY-MM-DD')

            for (let i = 0; i < this.selectedObject.resources.length; i++) {
                let img = await getProblemPhotos(this.selectedObject.resources[i]);
                let photo = URL.createObjectURL(new Blob([img.data], {
                type: img.headers['content-type']}));

                this.photos.push({
                    src: img,
                    url: photo,
                    id: this.selectedObject.resources[i]
                });
            }
        },
        changePhoto(direction){
            if(direction > 0){
                if (this.activePhotoIndex + 1 < this.photos.length) {
                    this.activePhotoIndex++;
                } else {
                    this.activePhotoIndex = 0;
                }
            } else {
                if (this.activePhotoIndex > 0) {
                    this.activePhotoIndex--;
                } else {
                    this.activePhotoIndex = this.photos.length - 1
                }
            }
        },
    },
    async mounted() {
      this.loadExistingProblem()
    }
}
</script>

<style scoped>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

textarea {
    height: 200px;
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

input[type="text"] {
    max-height: 300px;
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}


.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  width: 4%;
  height: 0;
  padding-bottom: 4%;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.photo {
    margin: 0 auto 0 auto;
    border-radius: 4px;
    object-fit: contain;
    width: 88%;
    height: 100%;
}

.thumbnails {
    overflow-y: hidden;
    overflow-x: scroll;
    max-width: 80%;
    margin: 0 auto 20px auto;
}


.blurred {
    opacity: 0.5;
    width: 100%;
    height: 37px;
}

.selected {
    width: 100%;
    height: 50px;
}

.problem-section {
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
}

.icon-desc {
    white-space: pre;
    text-align: center;
}

.selectedThumbnail {
    border: 4px solid #34758E;
}


.delete-image {
    width: 15px;
    height: 15px;
    cursor: pointer;
    position: relative;
    right: 0;
    top: 0;
    z-index: 1;
}

.thumbnail-container {
    position: relative;
    top: 0;
    left: 0;
    width: 64px;
    height: 64px;
    margin: 5px;
}

.thumbnail {
    width: 64px;
    height: 64px;
    margin: 5px;
    object-fit: cover;
    cursor: pointer;
    background: #34758E;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}

.two-columns-template-modal {
    display: grid;
    grid-template-columns: 40% 60%;
}

.one-column-template-modal {
    display: grid;
    grid-template-columns: 100%;
}

#photos-container {
    width: 100%;
    align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Visits/Problems/ProblemInfoModal.vue